import { Body3 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import i18n from '@flatsy/utils/translations'
import clsx from 'clsx'
import React from 'react'
import { useStyles } from './Style'

const ArrowStep2: React.FC<{ show?: boolean }> = ({ show }): React.ReactElement => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.container, classes.step2, show && 'active')}>
      <img src={FlatsyTheme.image.arrowStep2} className={classes.arrow} alt="arrow" />
      <div className={classes.stepNumber}>
        <Body3 className={classes.stepNumberInner}>2</Body3>
      </div>
      <Body3 className={classes.stepInformation}>
        {i18n.t('fill_in_type_of_each_document_below')}
      </Body3>
    </div>
  )
}

export default ArrowStep2
